//@mui
import { Box, Typography, useTheme, Grid, Stack } from "@mui/material";
import useCollapseDrawer from "~src/hooks/useCollapseDrawer";

export default function CoverCards() {
  const { isCollapse } = useCollapseDrawer();
  const theme = useTheme();
  return (
    <Grid container spacing={2} sx={{ my: 3 }}>
      <Grid size={{ xs: 12, md: isCollapse ? 3 : 4 , sm: 6 }}  >
        <Stack
          sx={{
            display: "flex",
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: "12px",
            backgroundColor: theme.palette.common.white,
            overflow: "hidden",
            height: 380,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <img
              style={{
                objectFit: "contain",
                width: 150,
                height: 150,
              }}
              src={"/assets/clip-arts/global-map.png"}
              alt="Ad-image"
            />
          </Box>
          <Box sx={{ paddingX: 4, textAlign: "center", pb: 4 }}>
            <Typography variant="h6">
              Global map of brands with website traffic, ads targeting and
              shipping data
            </Typography>
            <Typography sx={{ color: theme.palette.grey[500] }}>
              Unwrap the most promising markets and gather user data for
              location based promos
            </Typography>
          </Box>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: isCollapse ? 3 : 4 , sm: 6 }}  >
        <Stack
          sx={{
            display: "flex",
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: "12px",
            backgroundColor: theme.palette.common.white,
            overflow: "hidden",
            height: 380,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <img
              style={{
                objectFit: "contain",
                width: 150,
                height: 150,
              }}
              src={"/assets/clip-arts/audience-stats.png"}
              alt="Ad-image"
            />
          </Box>
          <Box sx={{ paddingX: 4, textAlign: "center", pb: 4 }}>
            <Typography variant="h6">
              Unwrap audience stats for various niches
            </Typography>
            <Typography sx={{ color: theme.palette.grey[500] }}>
              Compare the global reach and audience demographics of competitor
              sites
            </Typography>
          </Box>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, md: isCollapse ? 3 : 4 , sm: 6 }}  >
        <Stack
          sx={{
            display: "flex",
            border: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: "12px",
            backgroundColor: theme.palette.common.white,
            overflow: "hidden",
            height: 380,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 200,
            }}
          >
            <img
              style={{
                objectFit: "contain",
                width: 150,
                height: 150,
              }}
              src={"/assets/clip-arts/analysis.png"}
              alt="Ad-image"
            />
          </Box>
          <Box sx={{ paddingX: 4, textAlign: "center", pb: 4 }}>
            <Typography variant="h6">
              Perform analysis and discover growth opportunities
            </Typography>
            <Typography sx={{ color: theme.palette.grey[500] }}>
              Check competitor’s and potential partners metrics side by side for
              faster decision making
            </Typography>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
}
